import { useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../hooks/redux";
import { getHomeInfraCount } from "../../store/actions/homeActions";
import { ROUTES } from "../../config/routes";
import LoadingScreen from "../../components/loading-screen";
import { Notification } from "../../components/notification";
import { MAPPING_DETAILS } from "./common";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./style";
import { getDocumentTitle } from "../../utils/common";

const Home = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const locationRegExp = new RegExp(window.location.pathname, "i");

  const infraCount: IHomeInfraCount | null | undefined = useAppSelector(
    (state) => state.home.infraCountData
  );
  const showLoading: ILoading = useAppSelector(
    (state) => state.home.showLoading
  );

  const [selected, setSelected] = useState<string | null>(null);

  useEffect(() => {
    document.title = getDocumentTitle(ROUTES["home"].title);
  }, []);

  useEffect(() => {
    if (!infraCount) {
      dispatch(getHomeInfraCount());
    }
  }, [dispatch, infraCount]);

  return (
    <>
      <div className="lab-inventory-container">
        {showLoading.sourceAction === ROUTES["home"].title &&
          showLoading.state && <LoadingScreen />}
        {locationRegExp.test(ROUTES["home"].url) && <Notification />}
        <div className={styles.container}>
          <h1>Welcome to {process.env.REACT_APP_NAME}</h1>
          <div className={styles.inventoryGrid}>
            {infraCount && 
              Object.entries(infraCount).map(([key, value]) => {
                const mappingDetail = MAPPING_DETAILS[key];
                if (!mappingDetail) return null;
                return (
                  <div
                    key={key}
                    className={`${styles.box} ${
                      selected === key ? styles.selectedBox : ""
                    }`}
                    onClick={() => {
                      setSelected(key);
                      navigate(mappingDetail.url.replace("/*", ""));
                    }}
                  >
                    <strong>{mappingDetail.title}</strong>
                    <br />
                    {value}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
